import React, { useState } from "react";
import { Spin, message } from "antd";
import { useHistory } from "react-router-dom";
import RoleLoginForm from "../../components/RoleLoginForm/RoleLoginForm";
import _BankerService from "../../modules/BankerService";
import { COMMON_ERROR_MSG, SESSION_TOKEN } from "../../constants/constants";
import { routes } from "../../routes/Routes";
import {
    COMPLIANCE_ADMIN_ROLE_ID,
    SUPER_ADMIN_ROLE_ID,
    LOAN_OFFICER_ROLE_ID
} from "../../constants/DataConstants";

const RoleLoginBanker = () => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);

    const onFinishHandle = async (values) => {
        setLoading(true);
        try {
            const reqObj = {
                Email: values.email,
                Password: values.password,
                RoleId: 0
            };
            const res = await _BankerService.institutionLogin(reqObj);
            debugger
            if (res?.data?.IsSuccess) {
                const obj = res.data.Obj;
                const role = obj?.Role;
                const roleId = obj?.RoleId;

                if (roleId === LOAN_OFFICER_ROLE_ID) {
                    localStorage.setItem("LoanOfficerEmailId", obj.Email);
                    localStorage.setItem("LoanOfficerId", obj.Id);
                    localStorage.setItem("LoanOfficerFirstName", obj.FirstName);
                    localStorage.setItem(SESSION_TOKEN, obj.AuthToken);
                    localStorage.setItem("userRole", role);
                    localStorage.setItem("RoleId", obj.RoleId);
                    localStorage.setItem("IsLoanofficerFlag", JSON.stringify(true));
                    localStorage.setItem("IsFromNewLoginPage", routes.roleLoginBanker.path);
                    localStorage.setItem("listUserRoles", JSON.stringify(obj.listUserRoles));
                    localStorage.setItem("Password", values.password);
                    localStorage.setItem("BankerId", obj.Id);
                    localStorage.setItem("BankAdminId", obj.BankAdminId);
                    history.push(routes.loanOfficerDashboard.path);
                } else if (roleId === SUPER_ADMIN_ROLE_ID) {
                    localStorage.setItem("IsLoanofficerFlag", JSON.stringify(false));
                    localStorage.setItem("IsBankAdminFlag", JSON.stringify(true));
                    localStorage.setItem("BankAdminEmailId", obj.Email);
                    localStorage.setItem("BankAdminId", obj.Id);
                    localStorage.setItem("BankAdminFirstName", obj.FirstName);
                    localStorage.setItem(SESSION_TOKEN, obj.AuthToken);
                    localStorage.setItem("userRole", role);
                    localStorage.setItem("RoleId", obj.RoleId);
                    localStorage.setItem("IsFromNewLoginPage", routes.roleLoginBanker.path);
                    history.push(routes.bankadmindashboard.path);
                } else if (roleId === COMPLIANCE_ADMIN_ROLE_ID) {
                    localStorage.setItem("IsLoanofficerFlag", JSON.stringify(false));
                    localStorage.setItem("IsBankAdminFlag", JSON.stringify(false));
                    localStorage.setItem("BankerEmailId", obj.Email);
                    localStorage.setItem("BankerId", obj.Id);
                    localStorage.setItem("BankerFirstName", obj.FirstName);
                    localStorage.setItem(SESSION_TOKEN, obj.AuthToken);
                    localStorage.setItem("userRole", role);
                    localStorage.setItem("RoleId", obj.RoleId);
                    localStorage.setItem("BankAdminId", obj.BankAdminId);
                    localStorage.setItem("IsFromNewLoginPage", routes.roleLoginBanker.path);
                    localStorage.setItem("listUserRoles", JSON.stringify(obj.listUserRoles));
                    localStorage.setItem("Password", values.password);
                    history.push(routes.complianceadmindashboard.path);
                } else {
                    // Banker and all other banker sub-roles
                    localStorage.setItem("IsLoanofficerFlag", JSON.stringify(false));
                    localStorage.setItem("BankerEmailId", obj.Email);
                    localStorage.setItem("BankerId", obj.Id);
                    localStorage.setItem("BankerFirstName", obj.FirstName);
                    localStorage.setItem(SESSION_TOKEN, obj.AuthToken);
                    localStorage.setItem("userRole", role);
                    localStorage.setItem("RoleId", obj.RoleId);
                    localStorage.setItem("BankAdminId", obj.BankAdminId);
                    localStorage.setItem("IsFromNewLoginPage", routes.roleLoginBanker.path);
                    localStorage.setItem("listUserRoles", JSON.stringify(obj.listUserRoles));
                    localStorage.setItem("Password", values.password);
                   
                    localStorage.setItem("BankAdminId", obj.BankAdminId);
                    history.push(routes.bankerdashboard.path);
                }
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const forgotPassword = () => {
        history.push({ pathname: routes.forgotBankerLoginPasswordSendOTP.path, state: { fromNewLoginPage: routes.roleLoginBanker.path } });
    };

    return (
        <Spin spinning={loading}>
            <RoleLoginForm
                title="Institutional Portal"
                onFinishHandle={onFinishHandle}
                forgotPassword={forgotPassword}
                isNewAccountCreateFlag={false}
                onBack={() => history.push(routes.loginNewPage.path)}
            />
        </Spin>
    );
};

export default RoleLoginBanker;
